// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.module.css */
.Header_appHeader__GDc7e {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    background-color: var(--color-header-bg, #f8f9fa);
    border-bottom: 1px solid var(--color-border, #dee2e6);
    font-size: 12px;
    color: var(--color-text, #333);
    /* height: 50px; */ /* 고정 높이 예시 -> 유동적으로 변경 */
    min-height: 50px; /* 최소 높이 설정 */
    height: auto; /* 컨텐츠에 따라 높이 자동 조절 */
    box-sizing: border-box;
    flex-wrap: nowrap; /* 내부 요소들이 줄바꿈되지 않도록 */
}

.Header_headerLeft__ttXYG {
    display: flex;
    align-items: center;
    gap: 20px; /* 타이틀과 메뉴바 사이 간격 */
    flex-shrink: 0; /* 왼쪽 영역이 줄어들지 않도록 */
}

.Header_headerCenter__CiwCg {
    display: flex;
    align-items: center;
    justify-content: center; /* 중앙 정렬 */
    flex-grow: 1; /* 남은 공간을 차지하여 중앙에 위치 */
    margin: 0 20px; /* 좌우 여백 */
    gap: 15px; /* connectionInfo와 zoomControls 사이 간격 */
}

.Header_connectionInfo__WOFDO {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: #e3f2fd;
    border: 1px solid #bbdefb;
    border-radius: 6px;
    padding: 4px 10px;
    color: #1565c0;
    font-weight: 500;
    font-size: 12px;
    white-space: nowrap;
}

/* 화면 비율 조정 컨트롤 스타일 */
.Header_zoomControls__XmP9c {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 4px 8px;
}

.Header_zoomButton__0zyX- {
    background: none;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    transition: all 0.2s ease;
}

.Header_zoomButton__0zyX-:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
}

.Header_zoomDisplay__SOkzw {
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    min-width: 35px;
    text-align: center;
}

.Header_zoomResetButton__Mp2y9 {
    background: none;
    border: 1px solid #007bff;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 11px;
    color: #007bff;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
}

.Header_zoomResetButton__Mp2y9:hover {
    background-color: #007bff;
    color: white;
}

.Header_darkModeToggle__CLYUY {
    background: none;
    border: 1px solid var(--color-border, #ddd);
    border-radius: 4px;
    padding: 3px 8px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    transition: background 0.15s;
}
.Header_darkModeToggle__CLYUY:hover {
    background: var(--color-bg-tertiary, #e8ecf0);
}

/* 언어 전환 — 다크모드 토글과 같은 톤으로 맞춘다 */
.Header_languageSelect__4OSnM {
    background: none;
    border: 1px solid var(--color-border, #ddd);
    border-radius: 4px;
    padding: 3px 6px;
    cursor: pointer;
    font-size: 12px;
    line-height: 1;
    color: inherit;
    transition: background 0.15s;
}
.Header_languageSelect__4OSnM:hover {
    background: var(--color-bg-tertiary, #e8ecf0);
}
/* 다크모드에서 option 목록이 흰 판으로 뜨지 않도록 */
[data-theme="dark"] .Header_languageSelect__4OSnM option {
    background: var(--color-bg-secondary);
    color: var(--color-text);
}

@media (prefers-reduced-motion: reduce) {
    .Header_darkModeToggle__CLYUY,
    .Header_languageSelect__4OSnM { transition: none; }
}

.Header_headerRight__VxUR3 {
    display: flex;
    align-items: center;
    flex-shrink: 0; /* 오른쪽 영역도 줄어들지 않도록 */
    white-space: nowrap; /* 내부 텍스트 줄바꿈 방지 */
    gap: 15px; /* 참여그룹과 사용자 메뉴 사이 간격 */
}

.Header_appTitle__BkgiM {
    font-size: 14px;
    font-weight: 700;
    color: #343a40;
    display: flex;
    align-items: center;
    gap: 6px;
}

.Header_appLogoTitle__KgbpW {
    height: 22px;
    width: auto;
}

.Header_appVersion__xnFxV {
    font-size: 9px;
    font-weight: 400;
    color: #999;
    vertical-align: super;
    margin-left: 2px;
}

.Header_menuBar__ABX\\+P {
    display: flex;
    gap: 10px;
    align-items: center; /* 메뉴 버튼들이 세로 중앙 정렬되도록 */
    flex-shrink: 0; /* 메뉴바가 줄어들지 않도록 */
}

.Header_menuItem__T8vcp {
    background: none;
    border: none;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.Header_menuItem__T8vcp:hover {
    background-color: #e9ecef;
}

.Header_userInfo__lzJ\\+c {
    position: relative;
    display: flex;
    align-items: center;
}

.Header_userButton__5Fpdq {
    background: none;
    border: none;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 12px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #007bff;
    font-weight: 500;
    transition: all 0.2s ease;
}

.Header_userButton__5Fpdq:hover {
    background-color: #e3f2fd;
    color: #1565c0;
}

.Header_userIcon__ZboGH {
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
    font-size: 1.1em;
}

.Header_userName__Ge\\+\\+- {
    font-weight: 600;
}

.Header_dropdownArrow__721V4 {
    font-size: 0.7em;
    margin-left: 4px;
    transition: transform 0.2s ease;
}

.Header_userButton__5Fpdq:hover .Header_dropdownArrow__721V4 {
    transform: rotate(180deg);
}

.Header_userDropdown__4gsUM {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background-color: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    z-index: 1000;
    overflow: hidden;
}

.Header_userDropdownHeader__mA3dY {
    padding: 16px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.Header_userDropdownName__EQqIS {
    font-weight: 600;
    color: #343a40;
    font-size: 0.95em;
    margin-bottom: 4px;
}

.Header_userDropdownEmail__MR73Y {
    color: #6c757d;
    font-size: 0.85em;
}

.Header_userDropdownDivider__sJ9NB {
    height: 1px;
    background-color: #dee2e6;
    margin: 0;
}

.Header_userDropdownItem__NmQT4 {
    width: 100%;
    padding: 12px 16px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 0.9em;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: background-color 0.2s ease;
}

.Header_userDropdownItem__NmQT4:hover {
    background-color: #f8f9fa;
}

.Header_logoutIcon__1vB\\+K,
.Header_editIcon__FJDUh,
.Header_passwordIcon__pRAzD,
.Header_withdrawalIcon__HerCs {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    font-size: 1em;
    min-width: 16px;
}

/* 추가된 드롭다운 스타일 */
.Header_menuContainer__ihXzU {
    position: relative; /* 드롭다운 위치의 기준점 */
}

.Header_dropdownMenu__2NtGH {
    position: absolute;
    top: calc(100% + 2px); /* 버튼 바로 아래 약간의 간격 */
    left: 0;
    background-color: white;
    border: 1px solid #ccc;
    /* border-top: none; 드롭다운 전체 테두리 유지 */
    list-style: none;
    margin: 0;
    padding: 5px 0; /* 드롭다운 내부 상하 패딩 */
    z-index: 1000; /* 다른 요소들 위에 표시 */
    min-width: 180px; /* 드롭다운 최소 너비 */
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-radius: 4px;
}

.Header_dropdownItem__1EgF\\+ {
    padding: 7px 15px; /* 아이템 내부 패딩 — 행간을 줄였다(2026-11-04 사용자 요청, 10px → 7px) */
    cursor: pointer;
    font-size: 0.95em;
    white-space: nowrap;
    color: #333; /* 아이템 텍스트 색상 */
    display: flex;
    justify-content: space-between; /* 메뉴 이름과 단축키를 양 끝으로 분산 */
    align-items: center;
}

.Header_dropdownItem__1EgF\\+:hover {
    background-color: #007bff;
    color: white;
}

.Header_menuItemShortcut__lsYoX {
    color: #888; /* 단축키 텍스트 색상 (예시) */
    font-size: 0.9em; /* 단축키 폰트 크기 (예시) */
    /* margin-left: auto; /* 이것도 오른쪽 정렬에 도움을 줄 수 있음 */
}

/* 참여그룹 드롭다운 스타일 */
.Header_participationGroupInfo__O2brO {
    position: relative;
    display: inline-block;
}

.Header_participationGroupButton__8D9iE {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.2s;
    font-size: 12px;
    color: #495057;
}

.Header_participationGroupButton__8D9iE:hover {
    background-color: #f8f9fa;
}

.Header_groupIcon__5KbHF {
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    font-size: 13px;
}

.Header_groupName__Unkes {
    font-weight: 500;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.Header_participationGroupDropdown__\\+U56L {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 280px;
    max-width: 320px;
    animation: Header_slideDown__5z32N 0.2s ease-out;
}

.Header_participationGroupDropdownHeader__PAKKK {
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    border-radius: 8px 8px 0 0;
    padding: 12px 16px;
}

.Header_participationGroupTitle__1FEiP {
    font-weight: 600;
    font-size: 12px;
    color: #495057;
}

.Header_currentGroupSection__yeYnq {
    padding: 12px 16px;
    background: #e7f3ff;
    border-bottom: 1px solid #b3d7ff;
}

.Header_currentGroupLabel__ibbRO {
    font-size: 0.8rem;
    color: #0056b3;
    margin-bottom: 4px;
    font-weight: 500;
}

.Header_currentGroupName__GWk6g {
    font-size: 12px;
    color: #0056b3;
    font-weight: 600;
}

.Header_participationGroupDropdownItem__mw0Xi {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 12px 16px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 0.9rem;
    color: #495057;
    text-align: left;
    transition: background-color 0.2s;
}

.Header_participationGroupDropdownItem__mw0Xi:hover {
    background-color: #f8f9fa;
}

.Header_participationGroupDropdownItem__mw0Xi.Header_selectedGroup__lBlBQ {
    background-color: #e7f3ff;
    color: #0056b3;
}

.Header_participationGroupDropdownItem__mw0Xi.Header_selectedGroup__lBlBQ:hover {
    background-color: #cce7ff;
}

.Header_availableGroupsLabel__xPyEb {
    padding: 8px 16px;
    font-size: 0.8rem;
    color: #6c757d;
    font-weight: 500;
    background: #f8f9fa;
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
}

.Header_participationGroupDivider__OiTq2 {
    height: 1px;
    background-color: #dee2e6;
}

.Header_joinIcon__vB7OB,
.Header_leaveIcon__mJxMt,
.Header_groupSelectIcon__KqxOu {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    font-size: 0.9rem;
    flex-shrink: 0;
    min-width: 16px;
}

@keyframes Header_slideDown__5z32N {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* About 모달 스타일 */
.Header_modalOverlay__76l12 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    /* 정보 모달은 화면 정중앙보다 약간 위쪽에 — 사용자 시선이 자연스럽게 닿도록 */
    align-items: flex-start;
    padding-top: calc(8vh / var(--app-zoom, 1));
    z-index: 10000;
    overflow-y: auto;
}

.Header_aboutModal__fnS-C {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    width: 480px;
    max-width: calc(92vw / var(--app-zoom, 1));
    max-height: calc(80vh / var(--app-zoom, 1));
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.Header_aboutModalHeader__lOnSf {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 24px;
    border-bottom: 1px solid #e1e5e9;
    background-color: #f8f9fa;
    min-height: 30px;
}

.Header_aboutModalHeader__lOnSf h3 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: #2c3e50;
}

.Header_closeButton__vjHer {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #6c757d;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.Header_closeButton__vjHer:hover {
    background-color: #e9ecef;
    color: #495057;
}

.Header_aboutModalContent__\\+f7Hw {
    padding: 22px 24px 18px;
    text-align: center;
    overflow-y: auto;
    color: #333;
}

.Header_aboutModalContent__\\+f7Hw h2 {
    margin: 0 0 8px 0;
    font-size: 1.6rem;
    font-weight: 700;
    color: #2c3e50;
    letter-spacing: -0.5px;
}

.Header_aboutModalContent__\\+f7Hw p {
    margin: 0;
    font-size: 0.95rem;
    color: #666666;
    font-weight: 500;
}

.Header_aboutTagline__8qerz {
    color: #6b7280;
    margin: 14px 0 4px !important;
    font-style: italic;
    font-size: 0.95rem;
}

/* "beta" 윗첨자 — 제목 옆에 작게 표시 */
.Header_aboutBeta__8ZcNl {
    font-size: 0.45em;
    font-weight: 600;
    color: #ef4444;
    margin-left: 4px;
    vertical-align: super;
    letter-spacing: 0.04em;
    text-transform: lowercase;
}
[data-theme="dark"] .Header_aboutBeta__8ZcNl {
    color: #f87171;
}

.Header_aboutMeta__zMb5F {
    display: flex;
    justify-content: center;
    gap: 24px;
    padding: 10px 0;
    margin: 0 0 16px;
    border-top: 1px dashed #e5e7eb;
    border-bottom: 1px dashed #e5e7eb;
    font-size: 12px;
}
.Header_aboutMetaRow__F0Ep- {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}
.Header_aboutMetaLabel__Oq9bj {
    color: #9ca3af;
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 0.05em;
}
.Header_aboutMetaValue__8y5A- {
    color: #1f2937;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.Header_aboutSection__rc3TU {
    text-align: left;
    margin-top: 14px;
}
.Header_aboutSectionTitle__FmciO {
    font-size: 12px;
    font-weight: 700;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin: 0 0 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid #e5e7eb;
}

.Header_aboutList__Kl1FN {
    list-style: none;
    padding: 0;
    margin: 0;
}
.Header_aboutList__Kl1FN li {
    font-size: 12px;
    color: #374151;
    padding: 3px 0 3px 12px;
    position: relative;
    line-height: 1.55;
}
.Header_aboutList__Kl1FN li::before {
    content: '·';
    position: absolute;
    left: 2px;
    color: #6b7280;
    font-weight: 700;
}
.Header_aboutList__Kl1FN kbd {
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-bottom-width: 2px;
    border-radius: 3px;
    padding: 0 4px;
    font-size: 11px;
    font-family: 'Consolas', 'Courier New', monospace;
    color: #1f2937;
}

.Header_aboutFooter__Cartc {
    margin-top: 18px;
    padding-top: 10px;
    border-top: 1px solid #e5e7eb;
    color: #9ca3af;
    font-size: 11px;
}

/* 메뉴 아이콘 스타일 */
.Header_menuIcon__XGJoC {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    line-height: 1;
    /* 한글 글자는 줄 상자 가운데보다 약 1px 아래에 그려진다 — 아이콘을 상자 정중앙에 두면 배율에 상관없이 1px 위로 떠 보였다(실측 2026-11-05) */
    transform: translateY(1px);
}

/* 메뉴 항목에 붙는 윗첨자 배지 (예: '개발중'). 작지만 가독성 유지. */
.Header_menuBadge__Gv9cW {
    font-size: 9px;
    font-weight: 500;
    margin-left: 3px;
    color: var(--color-text-secondary, #555);
    vertical-align: super;
    line-height: 1;
    letter-spacing: 0;
}
[data-theme="dark"] .Header_menuBadge__Gv9cW {
    color: var(--color-text-secondary, #aaa);
}

/* 관리자 알림 — 새 오류·재발·새 신고 건수 (화면 오류 수집 3단계) */
.Header_menuBadgeAlert__R7laf,
[data-theme="dark"] .Header_menuBadgeAlert__R7laf {
    padding: 1px 5px;
    border-radius: 8px;
    font-weight: 600;
    color: #fff;
    background: #c9463a;
}
.Header_menuItemBadge__Mnlea {
    margin-left: 8px;
    padding: 0 6px;
    border-radius: 8px;
    font-size: 10.5px;
    font-weight: 600;
    line-height: 16px;
    color: #fff;
    background: #c9463a;
}

.Header_subMenuIcon__70AKK {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    font-size: 0.8rem;
    color: #6c757d;
    min-width: 16px;
}

.Header_menuItemContent__HRhUR {
    display: flex;
    align-items: center;
    flex: 1 1;
}

.Header_dropdownItem__1EgF\\+ {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.Header_menuSeparator__ZdjkG {
    height: 1px;
    background-color: #dee2e6;
    margin: 4px 0;
    padding: 0 !important;
    cursor: default !important;
    pointer-events: none;
} 
/* 다크모드 — !important로 specificity 보장 */
[data-theme="dark"] .Header_appHeader__GDc7e { background: var(--color-header-bg) !important; border-color: var(--color-border) !important; color: var(--color-text) !important; }
[data-theme="dark"] .Header_menuItem__T8vcp { color: var(--color-text) !important; }
[data-theme="dark"] .Header_menuItem__T8vcp:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_dropdownMenu__2NtGH { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_dropdownItem__1EgF\\+ { color: var(--color-text) !important; }
[data-theme="dark"] .Header_dropdownItem__1EgF\\+:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_connectionInfo__WOFDO { background: #1a3a5c !important; border-color: #264f78 !important; color: #6cb6ff !important; }
[data-theme="dark"] .Header_zoomControls__XmP9c { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_zoomButton__0zyX- { color: var(--color-text-secondary) !important; border-color: var(--color-border) !important; background: var(--color-btn-bg) !important; }
[data-theme="dark"] .Header_zoomButton__0zyX-:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_zoomDisplay__SOkzw { color: var(--color-text) !important; }
[data-theme="dark"] .Header_zoomResetButton__Mp2y9 { color: var(--color-accent-fg) !important; border-color: var(--color-accent-fg) !important; background: transparent !important; }
[data-theme="dark"] .Header_zoomResetButton__Mp2y9:hover { background: var(--color-hover) !important; color: var(--color-text) !important; }
[data-theme="dark"] .Header_appTitle__BkgiM { color: var(--color-text) !important; }
[data-theme="dark"] .Header_appVersion__xnFxV { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_darkModeToggle__CLYUY { border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_darkModeToggle__CLYUY:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_headerRight__VxUR3 { color: var(--color-text) !important; }
[data-theme="dark"] .Header_participationGroupButton__8D9iE { color: var(--color-text-secondary) !important; }
[data-theme="dark"] .Header_participationGroupButton__8D9iE:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_participationGroupDropdown__\\+U56L { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_participationGroupDropdownItem__mw0Xi { color: var(--color-text) !important; }
[data-theme="dark"] .Header_participationGroupDropdownItem__mw0Xi:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_participationGroupDropdownHeader__PAKKK { border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_participationGroupDivider__OiTq2 { background: var(--color-border) !important; }
[data-theme="dark"] .Header_currentGroupSection__yeYnq { background: var(--color-bg-secondary) !important; }
[data-theme="dark"] .Header_currentGroupLabel__ibbRO { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_currentGroupName__GWk6g { color: var(--color-accent-fg) !important; }
/* 즐겨찾기 그룹 구분 라벨 — color 만 덮으면 밝은 배경(#f8f9fa)과 밝은 테두리(#dee2e6)가
   남아 다크에서 흰 띠로 보인다. 같은 드롭다운의 participationGroupDropdownHeader 와 같은 톤. */
[data-theme="dark"] .Header_availableGroupsLabel__xPyEb {
    color: var(--color-text-muted) !important;
    background: var(--color-bg-secondary) !important;
    border-top-color: var(--color-border) !important;
    border-bottom-color: var(--color-border) !important;
}

/* 선택된 그룹 — 다크 룰이 아예 없어서 밝은 파랑(#e7f3ff) 배경에 진한 파랑 글자가 그대로 남았다.
   다크에서는 배경색만으로 선택이 드러나므로 글자는 본문색을 쓴다. */
[data-theme="dark"] .Header_participationGroupDropdownItem__mw0Xi.Header_selectedGroup__lBlBQ {
    background-color: var(--color-active) !important;
    color: var(--color-text) !important;
}
[data-theme="dark"] .Header_participationGroupDropdownItem__mw0Xi.Header_selectedGroup__lBlBQ:hover {
    background-color: #0b5a8f !important;
}
[data-theme="dark"] .Header_groupIcon__5KbHF { color: var(--color-text-secondary) !important; }
[data-theme="dark"] .Header_groupName__Unkes { color: var(--color-text-secondary) !important; }
[data-theme="dark"] .Header_dropdownArrow__721V4 { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_userButton__5Fpdq { color: var(--color-accent-fg) !important; }
[data-theme="dark"] .Header_userButton__5Fpdq:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_userIcon__ZboGH { color: var(--color-accent-fg) !important; }
[data-theme="dark"] .Header_userName__Ge\\+\\+- { color: var(--color-text) !important; }
[data-theme="dark"] .Header_userDropdown__4gsUM { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_userDropdownHeader__mA3dY { border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_userDropdownName__EQqIS { color: var(--color-text) !important; }
[data-theme="dark"] .Header_userDropdownEmail__MR73Y { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_userDropdownDivider__sJ9NB { background: var(--color-border) !important; }
[data-theme="dark"] .Header_userDropdownItem__NmQT4 { color: var(--color-text) !important; }
[data-theme="dark"] .Header_userDropdownItem__NmQT4:hover { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_menuSeparator__ZdjkG { background: var(--color-border) !important; }
[data-theme="dark"] .Header_menuItemDisabled__J-Mat { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_modalOverlay__76l12 { background: rgba(0,0,0,0.7) !important; }
[data-theme="dark"] .Header_aboutModal__fnS-C { background: var(--color-bg-tertiary) !important; color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutModalHeader__lOnSf { border-color: var(--color-border) !important; background: var(--color-bg-secondary) !important; }
[data-theme="dark"] .Header_aboutModalHeader__lOnSf h3, [data-theme="dark"] .Header_aboutModalHeader__lOnSf h4 { color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutModalContent__\\+f7Hw { background: var(--color-bg-tertiary) !important; color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutModalContent__\\+f7Hw h2 { color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutModalContent__\\+f7Hw p { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_aboutTagline__8qerz { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_aboutMeta__zMb5F { border-top-color: var(--color-border) !important; border-bottom-color: var(--color-border) !important; }
[data-theme="dark"] .Header_aboutMetaLabel__Oq9bj { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_aboutMetaValue__8y5A- { color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutSectionTitle__FmciO { color: var(--color-text-secondary, var(--color-text)) !important; border-bottom-color: var(--color-border) !important; }
[data-theme="dark"] .Header_aboutList__Kl1FN li { color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutList__Kl1FN li::before { color: var(--color-text-muted) !important; }
[data-theme="dark"] .Header_aboutList__Kl1FN kbd { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; color: var(--color-text) !important; }
[data-theme="dark"] .Header_aboutFooter__Cartc { color: var(--color-text-muted) !important; border-top-color: var(--color-border) !important; }
[data-theme="dark"] .Header_participationGroupDropdownHeader__PAKKK { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_userDropdownHeader__mA3dY { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }
[data-theme="dark"] .Header_closeButton__vjHer { color: var(--color-text-muted) !important; }

/* 연결 유형 배지 (Phase 2) — 지금 어떤 성격의 DB 에 붙어 있는지 항상 보이게 */
.Header_connTypeBadge__VglXT {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 3px 10px; border-radius: 12px;
    border: 1px solid currentColor;
    font-size: 11px; font-weight: 600; white-space: nowrap;
    background: transparent;
    /* 연결 유형 색 — Header.js 가 --conn-color(밝은 배경용)/--conn-color-dark 를 인라인으로 넘긴다 */
    color: var(--conn-color);
}
.Header_connTypeDot__fMzRF { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; background: var(--conn-color); }
/* 다크모드 — 개발(#007bff) 같은 진한 색은 어두운 배경에서 안 보였다(2026-09-13). 같은 계열의 밝은 색으로 */
[data-theme="dark"] .Header_connTypeBadge__VglXT { color: var(--conn-color-dark, var(--conn-color)); }
[data-theme="dark"] .Header_connTypeDot__fMzRF { background: var(--conn-color-dark, var(--conn-color)); }
/* 배지 안의 세션 — 연결명 뒤에 붙는다. 연결만 보고 "연결됐는데 왜 실행이 안 되지" 라고
   묻게 두지 않으려면 실행 대상이 한 줄에 다 보여야 한다. */
.Header_connSession__imbML {
  opacity: 0.85;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 세션이 없으면 **실행 자체가 막힌다.** 흐린 회색으로 두면 "그냥 비어 있나" 로 읽히므로
   붉은색으로 못 박는다 — 배지의 연결 유형 색을 물려받지 않고 여기만 따로 칠한다. */
.Header_connSessionNone__0G\\+Xo {
  color: #dc2626;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

/* 탐색기와 실행 대상이 갈렸다는 **알림**. 실행 불가(붉은색)와 섞지 않는다. */
.Header_connElsewhere__rmse\\+ {
  opacity: 0.7;
  font-weight: 400;
  white-space: nowrap;
}

/* 다크에서 #dc2626 은 배경에 가라앉는다 — 앱의 오류색 토큰을 쓴다 */
[data-theme="dark"] .Header_connSessionNone__0G\\+Xo { color: var(--color-error-text); }

.Header_connTypeName__rfts7 {
    font-weight: 400; opacity: .75;
    max-width: 220px; overflow: hidden; text-overflow: ellipsis;
}

/* 운영 연결 경고 띠 — 레이아웃에 영향 없도록 inset shadow 로 그린다 */
.Header_prodHeader__lHfSB { box-shadow: inset 0 -3px 0 #dc3545; }

/* 메뉴 즐겨찾기 토글 아이콘 — 켜지면 진한 노란색. 예전엔 인라인 style 이라 다크모드에서 바꿀 수 없었다. */
/* 즐겨찾기 토글 — 버튼이지만 메뉴 아이콘처럼 보이게 기본 모양을 지운다.
   선택자를 두 클래스로 쓰는 이유: 전역 [data-theme="dark"] button { color } 가 아이콘 회색을 덮는다. */
.Header_subMenuIcon__70AKK.Header_subMenuIconFav__UFeKh {
    border: none;
    background: transparent;
    padding: 0;
    font: inherit;
    line-height: 1;
    color: #6c757d;
    cursor: pointer;
    transition: color 150ms ease;
}
.Header_subMenuIcon__70AKK.Header_subMenuIconFav__UFeKh:hover { color: #a16207; }
.Header_subMenuIcon__70AKK.Header_subMenuIconFav__UFeKh.Header_subMenuIconFavOn__eCtUB { color: #ca8a04; }
.Header_subMenuIcon__70AKK.Header_subMenuIconFav__UFeKh:focus-visible { outline: 1px solid currentColor; outline-offset: 2px; border-radius: 2px; }
/* 메뉴 글자는 고르는 대상이 아니다 — 누를 때 글자 선택·텍스트 커서가 생기지 않게 */
.Header_dropdownMenu__2NtGH { -webkit-user-select: none; user-select: none; }
[data-theme="dark"] .Header_subMenuIconFavOn__eCtUB { color: #fbbf24 !important; }
[data-theme="dark"] .Header_subMenuIconFav__UFeKh:hover { color: #fcd34d !important; }
@media (prefers-reduced-motion: reduce) {
    .Header_subMenuIconFav__UFeKh { transition: none; }
}

/* 보기 메뉴의 체크형 항목 — 켜짐 표시(✓). 아이콘과 같은 자리·폭이라 이름 줄이 흔들리지 않는다. */
.Header_menuCheck__2CgOV { color: var(--color-accent, #3b82f6); }
[data-theme="dark"] .Header_menuCheck__2CgOV { color: #6cb6ff !important; }

/* 드롭다운 메뉴 — 아이콘과 레이블을 세로 가운데로(사용자 지적 2026-09-13).
   레이블 줄 높이가 글꼴 기본값이면 한글 글꼴의 아래 여백 때문에 글자가 아이콘보다 처져 보인다.
   줄 높이를 글자 높이에 맞추고, 줄어든 만큼 최소 높이로 항목 높이를 그대로 둔다. */
.Header_menuItemContent__HRhUR { min-height: 20px; }
.Header_menuItemContent__HRhUR .Header_subMenuIcon__70AKK { line-height: 1; }
.Header_menuItemContent__HRhUR .Header_subMenuIcon__70AKK > svg { display: block; }
.Header_menuItemName__Mg2bQ { line-height: 1; }
.Header_menuItemShortcut__lsYoX { line-height: 1; }

/* 정보 창 — 새 버전 줄 (스탠드얼론만) */
.Header_aboutUpdateRow__RPb0P { color: #92400e; }
.Header_aboutUpdateRow__RPb0P a { color: #1d4ed8; font-weight: 600; margin-left: 4px; }
[data-theme="dark"] .Header_aboutUpdateRow__RPb0P { color: #fde68a; }
[data-theme="dark"] .Header_aboutUpdateRow__RPb0P a { color: #93c5fd; }

/* 2단 메뉴 — 「DB 전문가」 › 오라클 전문가 ▾ (2026-10-04). 눌러서 아래로 펼친다(아코디언) — 처음의 오른쪽 플라이아웃은 사용자 요청으로 걷어냈다 */
/* 하위 메뉴(플라이아웃, 2026-10-06) — 묶음 항목 오른쪽에 붙어 열린다. 일반 데스크톱 메뉴와 같은 모양:
   묶음 끝의 ▸, 열린 동안 묶음은 강조된 채로, 하위 메뉴는 바깥 드롭다운과 같은 상자(.dropdownMenu)를 쓴다. */
.Header_dropdownGroup__eSZBl { position: relative; }
.Header_dropdownGroupArrow__Bdyhq { margin-left: 12px; opacity: 0.7; flex-shrink: 0; }
.Header_dropdownGroupOpen__-2hyf { background-color: rgba(0, 123, 255, 0.12); }
.Header_dropdownMenu__2NtGH .Header_dropdownFlyout__v7wvf {
    top: -6px;                 /* 상자 안쪽 여백만큼 올려 첫 항목이 묶음과 같은 높이에 */
    left: 100%;
    margin-left: 1px;
    animation: Header_dropdown-flyout-fade__Qqa2Z 140ms ease-out;
}
.Header_dropdownMenu__2NtGH .Header_dropdownFlyoutFlip__aoAtR { left: auto; right: 100%; margin-left: 0; margin-right: 1px; }
.Header_dropdownItem__1EgF\\+:focus-visible { outline: 2px solid #007bff; outline-offset: -2px; }
.Header_dropdownItemDisabled__DRZ7E { cursor: default; color: #9ca3af !important; font-style: italic; }
.Header_dropdownItemDisabled__DRZ7E:hover { background-color: transparent !important; color: #9ca3af !important; }
@keyframes Header_dropdown-flyout-fade__Qqa2Z { from { opacity: 0; transform: translateX(-3px); } to { opacity: 1; transform: none; } }
[data-theme="dark"] .Header_dropdownGroupOpen__-2hyf { background: var(--color-hover) !important; }
[data-theme="dark"] .Header_dropdownItemDisabled__DRZ7E { color: var(--color-text-muted) !important; }
@media (prefers-reduced-motion: reduce) { .Header_dropdownMenu__2NtGH .Header_dropdownFlyout__v7wvf { animation: none; } }

/* ── 머리줄 압축(Header.js fitHeader) — 넘칠 때만 단계적으로. 화면 확대를 올리면 같은 창에서도 넘친다 ── */
.Header_appHeader__GDc7e[data-compact="1"],
.Header_appHeader__GDc7e[data-compact="2"],
.Header_appHeader__GDc7e[data-compact="3"] { padding: 0 10px; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_headerLeft__ttXYG,
.Header_appHeader__GDc7e[data-compact="2"] .Header_headerLeft__ttXYG,
.Header_appHeader__GDc7e[data-compact="3"] .Header_headerLeft__ttXYG { gap: 10px; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_menuBar__ABX\\+P,
.Header_appHeader__GDc7e[data-compact="2"] .Header_menuBar__ABX\\+P,
.Header_appHeader__GDc7e[data-compact="3"] .Header_menuBar__ABX\\+P { gap: 2px; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_headerCenter__CiwCg,
.Header_appHeader__GDc7e[data-compact="2"] .Header_headerCenter__CiwCg,
.Header_appHeader__GDc7e[data-compact="3"] .Header_headerCenter__CiwCg { margin: 0 8px; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_headerRight__VxUR3,
.Header_appHeader__GDc7e[data-compact="2"] .Header_headerRight__VxUR3,
.Header_appHeader__GDc7e[data-compact="3"] .Header_headerRight__VxUR3 { gap: 8px; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_connTypeName__rfts7,
.Header_appHeader__GDc7e[data-compact="2"] .Header_connTypeName__rfts7,
.Header_appHeader__GDc7e[data-compact="3"] .Header_connTypeName__rfts7 { display: none; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_groupName__Unkes,
.Header_appHeader__GDc7e[data-compact="2"] .Header_groupName__Unkes { max-width: 90px; }
.Header_appHeader__GDc7e[data-compact="1"] .Header_userName__Ge\\+\\+-,
.Header_appHeader__GDc7e[data-compact="2"] .Header_userName__Ge\\+\\+- { display: inline-block; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle; }
/* 2 — 메뉴는 아이콘만 */
.Header_appHeader__GDc7e[data-compact="2"] .Header_menuLabel__PTJd\\+,
.Header_appHeader__GDc7e[data-compact="3"] .Header_menuLabel__PTJd\\+ { display: none; }
.Header_appHeader__GDc7e[data-compact="2"] .Header_menuItem__T8vcp,
.Header_appHeader__GDc7e[data-compact="3"] .Header_menuItem__T8vcp { padding: 6px 7px; }
/* 3 — 이름 글자를 걷어 낸다(아이콘·툴팁은 남는다) */
.Header_appHeader__GDc7e[data-compact="3"] .Header_groupName__Unkes,
.Header_appHeader__GDc7e[data-compact="3"] .Header_userName__Ge\\+\\+-,
.Header_appHeader__GDc7e[data-compact="3"] .Header_connSession__imbML,
.Header_appHeader__GDc7e[data-compact="3"] .Header_connSessionNone__0G\\+Xo,
.Header_appHeader__GDc7e[data-compact="3"] .Header_zoomResetButton__Mp2y9 { display: none; }

/* 켜고 끄는 항목의 즐겨찾기 별(분석 모드·AI 에이전트, 2026-10-19) — ✓ 가 왼쪽 자리를 써서 오른쪽 끝에 둔다 */
.Header_menuItemPin__Si5bQ {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border: none;
    border-radius: 3px;
    background: transparent;
    color: #9ca3af;
    cursor: pointer;
    opacity: 0.7;
    transition: color 150ms ease, opacity 150ms ease;
}
.Header_menuItemPin__Si5bQ:hover { opacity: 1; }
.Header_menuItemPin__Si5bQ.Header_menuItemPinOn__NA60E { color: #ca8a04; opacity: 1; }
.Header_menuItemPin__Si5bQ.Header_menuItemPinOn__NA60E svg { fill: currentColor; }
[data-theme="dark"] .Header_menuItemPin__Si5bQ.Header_menuItemPinOn__NA60E { color: #fbbf24; }
@media (prefers-reduced-motion: reduce) {
    .Header_menuItemPin__Si5bQ { transition: none; }
}

/* 확대 조절자의 −/+ 아이콘 — 숫자(100%)의 잉크가 줄 상자 가운데보다 약 1px 아래라 맞춘다(2026-11-05) */
.Header_zoomButton__0zyX- svg { transform: translateY(1px); }
`, "",{"version":3,"sources":["webpack://./src/components/Header.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iDAAiD;IACjD,qDAAqD;IACrD,eAAe;IACf,8BAA8B;IAC9B,kBAAkB,EAAE,yBAAyB;IAC7C,gBAAgB,EAAE,aAAa;IAC/B,YAAY,EAAE,qBAAqB;IACnC,sBAAsB;IACtB,iBAAiB,EAAE,sBAAsB;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,mBAAmB;IAC9B,cAAc,EAAE,oBAAoB;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAE,UAAU;IACnC,YAAY,EAAE,uBAAuB;IACrC,cAAc,EAAE,UAAU;IAC1B,SAAS,EAAE,uCAAuC;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,4BAA4B;AAChC;AACA;IACI,6CAA6C;AACjD;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;IACd,4BAA4B;AAChC;AACA;IACI,6CAA6C;AACjD;AACA,mCAAmC;AACnC;IACI,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA;IACI;oCACkB,gBAAgB,EAAE;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc,EAAE,qBAAqB;IACrC,mBAAmB,EAAE,kBAAkB;IACvC,SAAS,EAAE,uBAAuB;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB,EAAE,wBAAwB;IAC7C,cAAc,EAAE,kBAAkB;AACtC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB,EAAE,iBAAiB;AACzC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB,EAAE,oBAAoB;IAC3C,OAAO;IACP,uBAAuB;IACvB,sBAAsB;IACtB,qCAAqC;IACrC,gBAAgB;IAChB,SAAS;IACT,cAAc,EAAE,kBAAkB;IAClC,aAAa,EAAE,iBAAiB;IAChC,gBAAgB,EAAE,eAAe;IACjC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB,EAAE,uDAAuD;IAC1E,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW,EAAE,eAAe;IAC5B,aAAa;IACb,8BAA8B,EAAE,yBAAyB;IACzD,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW,EAAE,oBAAoB;IACjC,gBAAgB,EAAE,mBAAmB;IACrC,iDAAiD;AACrD;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gDAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,+CAA+C;IAC/C,uBAAuB;IACvB,2CAA2C;IAC3C,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,0CAA0C;IAC1C,2CAA2C;IAC3C,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,iCAAiC;IACjC,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iDAAiD;IACjD,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,4FAA4F;IAC5F,0BAA0B;AAC9B;;AAEA,6CAA6C;AAC7C;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;IACxC,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,wCAAwC;AAC5C;;AAEA,4CAA4C;AAC5C;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,0BAA0B;IAC1B,oBAAoB;AACxB;AACA,sCAAsC;AACtC,+CAA0C,6CAA6C,EAAE,4CAA4C,EAAE,mCAAmC,EAAE;AAC5K,8CAAyC,mCAAmC,EAAE;AAC9E,oDAA+C,yCAAyC,EAAE;AAC1F,kDAA6C,+CAA+C,EAAE,4CAA4C,EAAE;AAC5I,mDAA6C,mCAAmC,EAAE;AAClF,yDAAmD,yCAAyC,EAAE;AAC9F,oDAA+C,8BAA8B,EAAE,gCAAgC,EAAE,yBAAyB,EAAE;AAC5I,kDAA6C,gDAAgD,EAAE,4CAA4C,EAAE;AAC7I,gDAA2C,6CAA6C,EAAE,4CAA4C,EAAE,0CAA0C,EAAE;AACpL,sDAAiD,yCAAyC,EAAE;AAC5F,iDAA4C,mCAAmC,EAAE;AACjF,qDAAgD,wCAAwC,EAAE,+CAA+C,EAAE,kCAAkC,EAAE;AAC/K,2DAAsD,yCAAyC,EAAE,mCAAmC,EAAE;AACtI,8CAAyC,mCAAmC,EAAE;AAC9E,gDAA2C,yCAAyC,EAAE;AACtF,oDAA+C,4CAA4C,EAAE;AAC7F,0DAAqD,yCAAyC,EAAE;AAChG,iDAA4C,mCAAmC,EAAE;AACjF,8DAAyD,6CAA6C,EAAE;AACxG,oEAA+D,yCAAyC,EAAE;AAC1G,iEAA2D,+CAA+C,EAAE,4CAA4C,EAAE;AAC1J,oEAA+D,mCAAmC,EAAE;AACpG,0EAAqE,yCAAyC,EAAE;AAChH,sEAAiE,4CAA4C,EAAE;AAC/G,+DAA0D,0CAA0C,EAAE;AACtG,yDAAoD,gDAAgD,EAAE;AACtG,uDAAkD,yCAAyC,EAAE;AAC7F,sDAAiD,wCAAwC,EAAE;AAC3F;wEACwE;AACxE;IACI,yCAAyC;IACzC,gDAAgD;IAChD,gDAAgD;IAChD,mDAAmD;AACvD;;AAEA;wCACwC;AACxC;IACI,gDAAgD;IAChD,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA,+CAA0C,6CAA6C,EAAE;AACzF,+CAA0C,6CAA6C,EAAE;AACzF,mDAA8C,yCAAyC,EAAE;AACzF,gDAA2C,wCAAwC,EAAE;AACrF,sDAAiD,yCAAyC,EAAE;AAC5F,8CAAyC,wCAAwC,EAAE;AACnF,gDAAyC,mCAAmC,EAAE;AAC9E,kDAA6C,+CAA+C,EAAE,4CAA4C,EAAE;AAC5I,wDAAmD,4CAA4C,EAAE;AACjG,sDAAiD,mCAAmC,EAAE;AACtF,uDAAkD,yCAAyC,EAAE;AAC7F,yDAAoD,0CAA0C,EAAE;AAChG,sDAAiD,mCAAmC,EAAE;AACtF,4DAAuD,yCAAyC,EAAE;AAClG,mDAA8C,0CAA0C,EAAE;AAC1F,sDAAiD,yCAAyC,EAAE;AAC5F,kDAA6C,sCAAsC,EAAE;AACrF,gDAA2C,+CAA+C,EAAE,mCAAmC,EAAE;AACjI,sDAAiD,4CAA4C,EAAE,gDAAgD,EAAE;AACjJ,iHAAuG,mCAAmC,EAAE;AAC5I,wDAAkD,+CAA+C,EAAE,mCAAmC,EAAE;AACxI,2DAAqD,mCAAmC,EAAE;AAC1F,0DAAoD,yCAAyC,EAAE;AAC/F,kDAA6C,yCAAyC,EAAE;AACxF,+CAA0C,gDAAgD,EAAE,mDAAmD,EAAE;AACjJ,oDAA+C,yCAAyC,EAAE;AAC1F,oDAA+C,mCAAmC,EAAE;AACpF,uDAAkD,gEAAgE,EAAE,mDAAmD,EAAE;AACzK,kDAA6C,mCAAmC,EAAE;AAClF,0DAAqD,yCAAyC,EAAE;AAChG,mDAA8C,gDAAgD,EAAE,4CAA4C,EAAE,mCAAmC,EAAE;AACnL,iDAA4C,yCAAyC,EAAE,gDAAgD,EAAE;AACzI,sEAAiE,gDAAgD,EAAE,4CAA4C,EAAE;AACjK,wDAAmD,gDAAgD,EAAE,4CAA4C,EAAE;AACnJ,iDAA4C,yCAAyC,EAAE;;AAEvF,sDAAsD;AACtD;IACI,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;IACnD,iBAAiB,EAAE,mBAAmB;IACtC,8BAA8B;IAC9B,eAAe,EAAE,gBAAgB,EAAE,mBAAmB;IACtD,uBAAuB;IACvB,6EAA6E;IAC7E,wBAAwB;AAC5B;AACA,6BAAe,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE,6BAA6B,EAAE;AAC3G,0EAA0E;AAC1E,mDAA8C,gDAAgD,EAAE;AAChG,iDAA4C,qDAAqD,EAAE;AACnG;qCACqC;AACrC;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;mDACmD;AACnD;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C,sDAAgD,8BAA8B,EAAE;;AAEhF;IACI,gBAAgB,EAAE,YAAY;IAC9B,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB;AAC/D;;AAEA,iDAAiD;AACjD,4BAAc,kCAAkC,EAAE;;AAElD,mEAAmE;AACnE;8EAC8E;AAC9E;IACI,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,cAAc;IACd,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;AACA,gEAAoC,cAAc,EAAE;AACpD,yFAA+C,cAAc,EAAE;AAC/D,wEAA4C,+BAA+B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACtH,mDAAmD;AACnD,8BAAgB,yBAAiB,EAAjB,iBAAiB,EAAE;AACnC,sDAAiD,yBAAyB,EAAE;AAC5E,0DAAqD,yBAAyB,EAAE;AAChF;IACI,gCAAkB,gBAAgB,EAAE;AACxC;;AAEA,6DAA6D;AAC7D,2BAAa,mCAAmC,EAAE;AAClD,+CAA0C,yBAAyB,EAAE;;AAErE;;mDAEmD;AACnD,iCAAmB,gBAAgB,EAAE;AACrC,4DAAgC,cAAc,EAAE;AAChD,kEAAsC,cAAc,EAAE;AACtD,8BAAgB,cAAc,EAAE;AAChC,kCAAoB,cAAc,EAAE;;AAEpC,2BAA2B;AAC3B,gCAAkB,cAAc,EAAE;AAClC,kCAAoB,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACxE,oDAAsC,cAAc,EAAE;AACtD,sDAAwC,cAAc,EAAE;;AAExD,gGAAgG;AAChG;yEACyE;AACzE,+BAAiB,kBAAkB,EAAE;AACrC,oCAAsB,iBAAiB,EAAE,YAAY,EAAE,cAAc,EAAE;AACvE,mCAAqB,yCAAyC,EAAE;AAChE;IACI,SAAS,kBAAkB,mCAAmC;IAC9D,UAAU;IACV,gBAAgB;IAChB,4DAA8C;AAClD;AACA,gEAAoC,UAAU,EAAE,WAAW,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAChG,6CAA8B,0BAA0B,EAAE,oBAAoB,EAAE;AAChF,sCAAwB,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACxF,4CAA8B,wCAAwC,EAAE,yBAAyB,EAAE;AACnG,gDAAkC,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AACxH,uDAAkD,yCAAyC,EAAE;AAC7F,0DAAqD,yCAAyC,EAAE;AAChG,0CAA0C,4DAAgC,eAAe,EAAE,EAAE;;AAE7F,4EAA4E;AAC5E;;6CAE+B,eAAe,EAAE;AAChD;;uEAE2C,SAAS,EAAE;AACtD;;qEAEwC,QAAQ,EAAE;AAClD;;yEAE6C,aAAa,EAAE;AAC5D;;wEAE4C,QAAQ,EAAE;AACtD;;yEAE6C,aAAa,EAAE;AAC5D;sEAC0C,eAAe,EAAE;AAC3D;uEACyC,qBAAqB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,sBAAsB,EAAE;AAC1K,iBAAiB;AACjB;uEAC0C,aAAa,EAAE;AACzD;qEACyC,gBAAgB,EAAE;AAC3D,kCAAkC;AAClC;;;;4EAIgD,aAAa,EAAE;;AAE/D,0EAA0E;AAC1E;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,gDAAgD;AACpD;AACA,mCAAqB,UAAU,EAAE;AACjC,yDAA6B,cAAc,EAAE,UAAU,EAAE;AACzD,6DAAiC,kBAAkB,EAAE;AACrD,6EAA0D,cAAc,EAAE;AAC1E;IACI,6BAAe,gBAAgB,EAAE;AACrC;;AAEA,yEAAyE;AACzE,gCAAkB,0BAA0B,EAAE","sourcesContent":["/* Header.module.css */\n.appHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 20px;\n    background-color: var(--color-header-bg, #f8f9fa);\n    border-bottom: 1px solid var(--color-border, #dee2e6);\n    font-size: 12px;\n    color: var(--color-text, #333);\n    /* height: 50px; */ /* 고정 높이 예시 -> 유동적으로 변경 */\n    min-height: 50px; /* 최소 높이 설정 */\n    height: auto; /* 컨텐츠에 따라 높이 자동 조절 */\n    box-sizing: border-box;\n    flex-wrap: nowrap; /* 내부 요소들이 줄바꿈되지 않도록 */\n}\n\n.headerLeft {\n    display: flex;\n    align-items: center;\n    gap: 20px; /* 타이틀과 메뉴바 사이 간격 */\n    flex-shrink: 0; /* 왼쪽 영역이 줄어들지 않도록 */\n}\n\n.headerCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center; /* 중앙 정렬 */\n    flex-grow: 1; /* 남은 공간을 차지하여 중앙에 위치 */\n    margin: 0 20px; /* 좌우 여백 */\n    gap: 15px; /* connectionInfo와 zoomControls 사이 간격 */\n}\n\n.connectionInfo {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background-color: #e3f2fd;\n    border: 1px solid #bbdefb;\n    border-radius: 6px;\n    padding: 4px 10px;\n    color: #1565c0;\n    font-weight: 500;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n/* 화면 비율 조정 컨트롤 스타일 */\n.zoomControls {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    padding: 4px 8px;\n}\n\n.zoomButton {\n    background: none;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: bold;\n    color: #495057;\n    transition: all 0.2s ease;\n}\n\n.zoomButton:hover {\n    background-color: #e9ecef;\n    border-color: #adb5bd;\n}\n\n.zoomDisplay {\n    font-size: 12px;\n    font-weight: 500;\n    color: #495057;\n    min-width: 35px;\n    text-align: center;\n}\n\n.zoomResetButton {\n    background: none;\n    border: 1px solid #007bff;\n    border-radius: 4px;\n    padding: 2px 6px;\n    font-size: 11px;\n    color: #007bff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-weight: 500;\n}\n\n.zoomResetButton:hover {\n    background-color: #007bff;\n    color: white;\n}\n\n.darkModeToggle {\n    background: none;\n    border: 1px solid var(--color-border, #ddd);\n    border-radius: 4px;\n    padding: 3px 8px;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1;\n    transition: background 0.15s;\n}\n.darkModeToggle:hover {\n    background: var(--color-bg-tertiary, #e8ecf0);\n}\n\n/* 언어 전환 — 다크모드 토글과 같은 톤으로 맞춘다 */\n.languageSelect {\n    background: none;\n    border: 1px solid var(--color-border, #ddd);\n    border-radius: 4px;\n    padding: 3px 6px;\n    cursor: pointer;\n    font-size: 12px;\n    line-height: 1;\n    color: inherit;\n    transition: background 0.15s;\n}\n.languageSelect:hover {\n    background: var(--color-bg-tertiary, #e8ecf0);\n}\n/* 다크모드에서 option 목록이 흰 판으로 뜨지 않도록 */\n:global([data-theme=\"dark\"]) .languageSelect option {\n    background: var(--color-bg-secondary);\n    color: var(--color-text);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .darkModeToggle,\n    .languageSelect { transition: none; }\n}\n\n.headerRight {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0; /* 오른쪽 영역도 줄어들지 않도록 */\n    white-space: nowrap; /* 내부 텍스트 줄바꿈 방지 */\n    gap: 15px; /* 참여그룹과 사용자 메뉴 사이 간격 */\n}\n\n.appTitle {\n    font-size: 14px;\n    font-weight: 700;\n    color: #343a40;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.appLogoTitle {\n    height: 22px;\n    width: auto;\n}\n\n.appVersion {\n    font-size: 9px;\n    font-weight: 400;\n    color: #999;\n    vertical-align: super;\n    margin-left: 2px;\n}\n\n.menuBar {\n    display: flex;\n    gap: 10px;\n    align-items: center; /* 메뉴 버튼들이 세로 중앙 정렬되도록 */\n    flex-shrink: 0; /* 메뉴바가 줄어들지 않도록 */\n}\n\n.menuItem {\n    background: none;\n    border: none;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-size: 12px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.menuItem:hover {\n    background-color: #e9ecef;\n}\n\n.userInfo {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.userButton {\n    background: none;\n    border: none;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-size: 12px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #007bff;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.userButton:hover {\n    background-color: #e3f2fd;\n    color: #1565c0;\n}\n\n.userIcon {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 6px;\n    font-size: 1.1em;\n}\n\n.userName {\n    font-weight: 600;\n}\n\n.dropdownArrow {\n    font-size: 0.7em;\n    margin-left: 4px;\n    transition: transform 0.2s ease;\n}\n\n.userButton:hover .dropdownArrow {\n    transform: rotate(180deg);\n}\n\n.userDropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background-color: white;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    min-width: 200px;\n    z-index: 1000;\n    overflow: hidden;\n}\n\n.userDropdownHeader {\n    padding: 16px;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.userDropdownName {\n    font-weight: 600;\n    color: #343a40;\n    font-size: 0.95em;\n    margin-bottom: 4px;\n}\n\n.userDropdownEmail {\n    color: #6c757d;\n    font-size: 0.85em;\n}\n\n.userDropdownDivider {\n    height: 1px;\n    background-color: #dee2e6;\n    margin: 0;\n}\n\n.userDropdownItem {\n    width: 100%;\n    padding: 12px 16px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 0.9em;\n    color: #495057;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    transition: background-color 0.2s ease;\n}\n\n.userDropdownItem:hover {\n    background-color: #f8f9fa;\n}\n\n.logoutIcon,\n.editIcon,\n.passwordIcon,\n.withdrawalIcon {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 8px;\n    font-size: 1em;\n    min-width: 16px;\n}\n\n/* 추가된 드롭다운 스타일 */\n.menuContainer {\n    position: relative; /* 드롭다운 위치의 기준점 */\n}\n\n.dropdownMenu {\n    position: absolute;\n    top: calc(100% + 2px); /* 버튼 바로 아래 약간의 간격 */\n    left: 0;\n    background-color: white;\n    border: 1px solid #ccc;\n    /* border-top: none; 드롭다운 전체 테두리 유지 */\n    list-style: none;\n    margin: 0;\n    padding: 5px 0; /* 드롭다운 내부 상하 패딩 */\n    z-index: 1000; /* 다른 요소들 위에 표시 */\n    min-width: 180px; /* 드롭다운 최소 너비 */\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n    border-radius: 4px;\n}\n\n.dropdownItem {\n    padding: 7px 15px; /* 아이템 내부 패딩 — 행간을 줄였다(2026-11-04 사용자 요청, 10px → 7px) */\n    cursor: pointer;\n    font-size: 0.95em;\n    white-space: nowrap;\n    color: #333; /* 아이템 텍스트 색상 */\n    display: flex;\n    justify-content: space-between; /* 메뉴 이름과 단축키를 양 끝으로 분산 */\n    align-items: center;\n}\n\n.dropdownItem:hover {\n    background-color: #007bff;\n    color: white;\n}\n\n.menuItemShortcut {\n    color: #888; /* 단축키 텍스트 색상 (예시) */\n    font-size: 0.9em; /* 단축키 폰트 크기 (예시) */\n    /* margin-left: auto; /* 이것도 오른쪽 정렬에 도움을 줄 수 있음 */\n}\n\n/* 참여그룹 드롭다운 스타일 */\n.participationGroupInfo {\n    position: relative;\n    display: inline-block;\n}\n\n.participationGroupButton {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: none;\n    border: none;\n    padding: 8px 12px;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background-color 0.2s;\n    font-size: 12px;\n    color: #495057;\n}\n\n.participationGroupButton:hover {\n    background-color: #f8f9fa;\n}\n\n.groupIcon {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 4px;\n    font-size: 13px;\n}\n\n.groupName {\n    font-weight: 500;\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.participationGroupDropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    background: white;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    min-width: 280px;\n    max-width: 320px;\n    animation: slideDown 0.2s ease-out;\n}\n\n.participationGroupDropdownHeader {\n    background: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n    border-radius: 8px 8px 0 0;\n    padding: 12px 16px;\n}\n\n.participationGroupTitle {\n    font-weight: 600;\n    font-size: 12px;\n    color: #495057;\n}\n\n.currentGroupSection {\n    padding: 12px 16px;\n    background: #e7f3ff;\n    border-bottom: 1px solid #b3d7ff;\n}\n\n.currentGroupLabel {\n    font-size: 0.8rem;\n    color: #0056b3;\n    margin-bottom: 4px;\n    font-weight: 500;\n}\n\n.currentGroupName {\n    font-size: 12px;\n    color: #0056b3;\n    font-weight: 600;\n}\n\n.participationGroupDropdownItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 12px 16px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 0.9rem;\n    color: #495057;\n    text-align: left;\n    transition: background-color 0.2s;\n}\n\n.participationGroupDropdownItem:hover {\n    background-color: #f8f9fa;\n}\n\n.participationGroupDropdownItem.selectedGroup {\n    background-color: #e7f3ff;\n    color: #0056b3;\n}\n\n.participationGroupDropdownItem.selectedGroup:hover {\n    background-color: #cce7ff;\n}\n\n.availableGroupsLabel {\n    padding: 8px 16px;\n    font-size: 0.8rem;\n    color: #6c757d;\n    font-weight: 500;\n    background: #f8f9fa;\n    border-top: 1px solid #dee2e6;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.participationGroupDivider {\n    height: 1px;\n    background-color: #dee2e6;\n}\n\n.joinIcon,\n.leaveIcon,\n.groupSelectIcon {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 8px;\n    font-size: 0.9rem;\n    flex-shrink: 0;\n    min-width: 16px;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* About 모달 스타일 */\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    /* 정보 모달은 화면 정중앙보다 약간 위쪽에 — 사용자 시선이 자연스럽게 닿도록 */\n    align-items: flex-start;\n    padding-top: calc(8vh / var(--app-zoom, 1));\n    z-index: 10000;\n    overflow-y: auto;\n}\n\n.aboutModal {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n    width: 480px;\n    max-width: calc(92vw / var(--app-zoom, 1));\n    max-height: calc(80vh / var(--app-zoom, 1));\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.aboutModalHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2px 24px;\n    border-bottom: 1px solid #e1e5e9;\n    background-color: #f8f9fa;\n    min-height: 30px;\n}\n\n.aboutModalHeader h3 {\n    margin: 0;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #2c3e50;\n}\n\n.closeButton {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #6c757d;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n    background-color: #e9ecef;\n    color: #495057;\n}\n\n.aboutModalContent {\n    padding: 22px 24px 18px;\n    text-align: center;\n    overflow-y: auto;\n    color: #333;\n}\n\n.aboutModalContent h2 {\n    margin: 0 0 8px 0;\n    font-size: 1.6rem;\n    font-weight: 700;\n    color: #2c3e50;\n    letter-spacing: -0.5px;\n}\n\n.aboutModalContent p {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #666666;\n    font-weight: 500;\n}\n\n.aboutTagline {\n    color: #6b7280;\n    margin: 14px 0 4px !important;\n    font-style: italic;\n    font-size: 0.95rem;\n}\n\n/* \"beta\" 윗첨자 — 제목 옆에 작게 표시 */\n.aboutBeta {\n    font-size: 0.45em;\n    font-weight: 600;\n    color: #ef4444;\n    margin-left: 4px;\n    vertical-align: super;\n    letter-spacing: 0.04em;\n    text-transform: lowercase;\n}\n:global([data-theme=\"dark\"]) .aboutBeta {\n    color: #f87171;\n}\n\n.aboutMeta {\n    display: flex;\n    justify-content: center;\n    gap: 24px;\n    padding: 10px 0;\n    margin: 0 0 16px;\n    border-top: 1px dashed #e5e7eb;\n    border-bottom: 1px dashed #e5e7eb;\n    font-size: 12px;\n}\n.aboutMetaRow {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n}\n.aboutMetaLabel {\n    color: #9ca3af;\n    text-transform: uppercase;\n    font-size: 10px;\n    letter-spacing: 0.05em;\n}\n.aboutMetaValue {\n    color: #1f2937;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n\n.aboutSection {\n    text-align: left;\n    margin-top: 14px;\n}\n.aboutSectionTitle {\n    font-size: 12px;\n    font-weight: 700;\n    color: #4b5563;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    margin: 0 0 6px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.aboutList {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.aboutList li {\n    font-size: 12px;\n    color: #374151;\n    padding: 3px 0 3px 12px;\n    position: relative;\n    line-height: 1.55;\n}\n.aboutList li::before {\n    content: '·';\n    position: absolute;\n    left: 2px;\n    color: #6b7280;\n    font-weight: 700;\n}\n.aboutList kbd {\n    background: #f3f4f6;\n    border: 1px solid #d1d5db;\n    border-bottom-width: 2px;\n    border-radius: 3px;\n    padding: 0 4px;\n    font-size: 11px;\n    font-family: 'Consolas', 'Courier New', monospace;\n    color: #1f2937;\n}\n\n.aboutFooter {\n    margin-top: 18px;\n    padding-top: 10px;\n    border-top: 1px solid #e5e7eb;\n    color: #9ca3af;\n    font-size: 11px;\n}\n\n/* 메뉴 아이콘 스타일 */\n.menuIcon {\n    display: inline-flex;\n    align-items: center;\n    font-size: 13px;\n    line-height: 1;\n    /* 한글 글자는 줄 상자 가운데보다 약 1px 아래에 그려진다 — 아이콘을 상자 정중앙에 두면 배율에 상관없이 1px 위로 떠 보였다(실측 2026-11-05) */\n    transform: translateY(1px);\n}\n\n/* 메뉴 항목에 붙는 윗첨자 배지 (예: '개발중'). 작지만 가독성 유지. */\n.menuBadge {\n    font-size: 9px;\n    font-weight: 500;\n    margin-left: 3px;\n    color: var(--color-text-secondary, #555);\n    vertical-align: super;\n    line-height: 1;\n    letter-spacing: 0;\n}\n:global([data-theme=\"dark\"]) .menuBadge {\n    color: var(--color-text-secondary, #aaa);\n}\n\n/* 관리자 알림 — 새 오류·재발·새 신고 건수 (화면 오류 수집 3단계) */\n.menuBadgeAlert,\n:global([data-theme=\"dark\"]) .menuBadgeAlert {\n    padding: 1px 5px;\n    border-radius: 8px;\n    font-weight: 600;\n    color: #fff;\n    background: #c9463a;\n}\n.menuItemBadge {\n    margin-left: 8px;\n    padding: 0 6px;\n    border-radius: 8px;\n    font-size: 10.5px;\n    font-weight: 600;\n    line-height: 16px;\n    color: #fff;\n    background: #c9463a;\n}\n\n.subMenuIcon {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 8px;\n    font-size: 0.8rem;\n    color: #6c757d;\n    min-width: 16px;\n}\n\n.menuItemContent {\n    display: flex;\n    align-items: center;\n    flex: 1;\n}\n\n.dropdownItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.menuSeparator {\n    height: 1px;\n    background-color: #dee2e6;\n    margin: 4px 0;\n    padding: 0 !important;\n    cursor: default !important;\n    pointer-events: none;\n} \n/* 다크모드 — !important로 specificity 보장 */\n:global([data-theme=\"dark\"]) .appHeader { background: var(--color-header-bg) !important; border-color: var(--color-border) !important; color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .menuItem { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .menuItem:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .dropdownMenu { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .dropdownItem { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .dropdownItem:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .connectionInfo { background: #1a3a5c !important; border-color: #264f78 !important; color: #6cb6ff !important; }\n:global([data-theme=\"dark\"]) .zoomControls { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .zoomButton { color: var(--color-text-secondary) !important; border-color: var(--color-border) !important; background: var(--color-btn-bg) !important; }\n:global([data-theme=\"dark\"]) .zoomButton:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .zoomDisplay { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .zoomResetButton { color: var(--color-accent-fg) !important; border-color: var(--color-accent-fg) !important; background: transparent !important; }\n:global([data-theme=\"dark\"]) .zoomResetButton:hover { background: var(--color-hover) !important; color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .appTitle { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .appVersion { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .darkModeToggle { border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .darkModeToggle:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .headerRight { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .participationGroupButton { color: var(--color-text-secondary) !important; }\n:global([data-theme=\"dark\"]) .participationGroupButton:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .participationGroupDropdown { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .participationGroupDropdownItem { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .participationGroupDropdownItem:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .participationGroupDropdownHeader { border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .participationGroupDivider { background: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .currentGroupSection { background: var(--color-bg-secondary) !important; }\n:global([data-theme=\"dark\"]) .currentGroupLabel { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .currentGroupName { color: var(--color-accent-fg) !important; }\n/* 즐겨찾기 그룹 구분 라벨 — color 만 덮으면 밝은 배경(#f8f9fa)과 밝은 테두리(#dee2e6)가\n   남아 다크에서 흰 띠로 보인다. 같은 드롭다운의 participationGroupDropdownHeader 와 같은 톤. */\n:global([data-theme=\"dark\"]) .availableGroupsLabel {\n    color: var(--color-text-muted) !important;\n    background: var(--color-bg-secondary) !important;\n    border-top-color: var(--color-border) !important;\n    border-bottom-color: var(--color-border) !important;\n}\n\n/* 선택된 그룹 — 다크 룰이 아예 없어서 밝은 파랑(#e7f3ff) 배경에 진한 파랑 글자가 그대로 남았다.\n   다크에서는 배경색만으로 선택이 드러나므로 글자는 본문색을 쓴다. */\n:global([data-theme=\"dark\"]) .participationGroupDropdownItem.selectedGroup {\n    background-color: var(--color-active) !important;\n    color: var(--color-text) !important;\n}\n:global([data-theme=\"dark\"]) .participationGroupDropdownItem.selectedGroup:hover {\n    background-color: #0b5a8f !important;\n}\n:global([data-theme=\"dark\"]) .groupIcon { color: var(--color-text-secondary) !important; }\n:global([data-theme=\"dark\"]) .groupName { color: var(--color-text-secondary) !important; }\n:global([data-theme=\"dark\"]) .dropdownArrow { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .userButton { color: var(--color-accent-fg) !important; }\n:global([data-theme=\"dark\"]) .userButton:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .userIcon { color: var(--color-accent-fg) !important; }\n:global([data-theme=\"dark\"]) .userName { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .userDropdown { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .userDropdownHeader { border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .userDropdownName { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .userDropdownEmail { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .userDropdownDivider { background: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .userDropdownItem { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .userDropdownItem:hover { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .menuSeparator { background: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .menuItemDisabled { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .modalOverlay { background: rgba(0,0,0,0.7) !important; }\n:global([data-theme=\"dark\"]) .aboutModal { background: var(--color-bg-tertiary) !important; color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutModalHeader { border-color: var(--color-border) !important; background: var(--color-bg-secondary) !important; }\n:global([data-theme=\"dark\"]) .aboutModalHeader h3, :global([data-theme=\"dark\"]) .aboutModalHeader h4 { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutModalContent { background: var(--color-bg-tertiary) !important; color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutModalContent h2 { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutModalContent p { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .aboutTagline { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .aboutMeta { border-top-color: var(--color-border) !important; border-bottom-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .aboutMetaLabel { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .aboutMetaValue { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutSectionTitle { color: var(--color-text-secondary, var(--color-text)) !important; border-bottom-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .aboutList li { color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutList li::before { color: var(--color-text-muted) !important; }\n:global([data-theme=\"dark\"]) .aboutList kbd { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; color: var(--color-text) !important; }\n:global([data-theme=\"dark\"]) .aboutFooter { color: var(--color-text-muted) !important; border-top-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .participationGroupDropdownHeader { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .userDropdownHeader { background: var(--color-bg-secondary) !important; border-color: var(--color-border) !important; }\n:global([data-theme=\"dark\"]) .closeButton { color: var(--color-text-muted) !important; }\n\n/* 연결 유형 배지 (Phase 2) — 지금 어떤 성격의 DB 에 붙어 있는지 항상 보이게 */\n.connTypeBadge {\n    display: inline-flex; align-items: center; gap: 6px;\n    padding: 3px 10px; border-radius: 12px;\n    border: 1px solid currentColor;\n    font-size: 11px; font-weight: 600; white-space: nowrap;\n    background: transparent;\n    /* 연결 유형 색 — Header.js 가 --conn-color(밝은 배경용)/--conn-color-dark 를 인라인으로 넘긴다 */\n    color: var(--conn-color);\n}\n.connTypeDot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; background: var(--conn-color); }\n/* 다크모드 — 개발(#007bff) 같은 진한 색은 어두운 배경에서 안 보였다(2026-09-13). 같은 계열의 밝은 색으로 */\n:global([data-theme=\"dark\"]) .connTypeBadge { color: var(--conn-color-dark, var(--conn-color)); }\n:global([data-theme=\"dark\"]) .connTypeDot { background: var(--conn-color-dark, var(--conn-color)); }\n/* 배지 안의 세션 — 연결명 뒤에 붙는다. 연결만 보고 \"연결됐는데 왜 실행이 안 되지\" 라고\n   묻게 두지 않으려면 실행 대상이 한 줄에 다 보여야 한다. */\n.connSession {\n  opacity: 0.85;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/* 세션이 없으면 **실행 자체가 막힌다.** 흐린 회색으로 두면 \"그냥 비어 있나\" 로 읽히므로\n   붉은색으로 못 박는다 — 배지의 연결 유형 색을 물려받지 않고 여기만 따로 칠한다. */\n.connSessionNone {\n  color: #dc2626;\n  font-style: normal;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* 탐색기와 실행 대상이 갈렸다는 **알림**. 실행 불가(붉은색)와 섞지 않는다. */\n.connElsewhere {\n  opacity: 0.7;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\n/* 다크에서 #dc2626 은 배경에 가라앉는다 — 앱의 오류색 토큰을 쓴다 */\n:global([data-theme=\"dark\"]) .connSessionNone { color: var(--color-error-text); }\n\n.connTypeName {\n    font-weight: 400; opacity: .75;\n    max-width: 220px; overflow: hidden; text-overflow: ellipsis;\n}\n\n/* 운영 연결 경고 띠 — 레이아웃에 영향 없도록 inset shadow 로 그린다 */\n.prodHeader { box-shadow: inset 0 -3px 0 #dc3545; }\n\n/* 메뉴 즐겨찾기 토글 아이콘 — 켜지면 진한 노란색. 예전엔 인라인 style 이라 다크모드에서 바꿀 수 없었다. */\n/* 즐겨찾기 토글 — 버튼이지만 메뉴 아이콘처럼 보이게 기본 모양을 지운다.\n   선택자를 두 클래스로 쓰는 이유: 전역 [data-theme=\"dark\"] button { color } 가 아이콘 회색을 덮는다. */\n.subMenuIcon.subMenuIconFav {\n    border: none;\n    background: transparent;\n    padding: 0;\n    font: inherit;\n    line-height: 1;\n    color: #6c757d;\n    cursor: pointer;\n    transition: color 150ms ease;\n}\n.subMenuIcon.subMenuIconFav:hover { color: #a16207; }\n.subMenuIcon.subMenuIconFav.subMenuIconFavOn { color: #ca8a04; }\n.subMenuIcon.subMenuIconFav:focus-visible { outline: 1px solid currentColor; outline-offset: 2px; border-radius: 2px; }\n/* 메뉴 글자는 고르는 대상이 아니다 — 누를 때 글자 선택·텍스트 커서가 생기지 않게 */\n.dropdownMenu { user-select: none; }\n:global([data-theme=\"dark\"]) .subMenuIconFavOn { color: #fbbf24 !important; }\n:global([data-theme=\"dark\"]) .subMenuIconFav:hover { color: #fcd34d !important; }\n@media (prefers-reduced-motion: reduce) {\n    .subMenuIconFav { transition: none; }\n}\n\n/* 보기 메뉴의 체크형 항목 — 켜짐 표시(✓). 아이콘과 같은 자리·폭이라 이름 줄이 흔들리지 않는다. */\n.menuCheck { color: var(--color-accent, #3b82f6); }\n:global([data-theme=\"dark\"]) .menuCheck { color: #6cb6ff !important; }\n\n/* 드롭다운 메뉴 — 아이콘과 레이블을 세로 가운데로(사용자 지적 2026-09-13).\n   레이블 줄 높이가 글꼴 기본값이면 한글 글꼴의 아래 여백 때문에 글자가 아이콘보다 처져 보인다.\n   줄 높이를 글자 높이에 맞추고, 줄어든 만큼 최소 높이로 항목 높이를 그대로 둔다. */\n.menuItemContent { min-height: 20px; }\n.menuItemContent .subMenuIcon { line-height: 1; }\n.menuItemContent .subMenuIcon > svg { display: block; }\n.menuItemName { line-height: 1; }\n.menuItemShortcut { line-height: 1; }\n\n/* 정보 창 — 새 버전 줄 (스탠드얼론만) */\n.aboutUpdateRow { color: #92400e; }\n.aboutUpdateRow a { color: #1d4ed8; font-weight: 600; margin-left: 4px; }\n[data-theme=\"dark\"] .aboutUpdateRow { color: #fde68a; }\n[data-theme=\"dark\"] .aboutUpdateRow a { color: #93c5fd; }\n\n/* 2단 메뉴 — 「DB 전문가」 › 오라클 전문가 ▾ (2026-10-04). 눌러서 아래로 펼친다(아코디언) — 처음의 오른쪽 플라이아웃은 사용자 요청으로 걷어냈다 */\n/* 하위 메뉴(플라이아웃, 2026-10-06) — 묶음 항목 오른쪽에 붙어 열린다. 일반 데스크톱 메뉴와 같은 모양:\n   묶음 끝의 ▸, 열린 동안 묶음은 강조된 채로, 하위 메뉴는 바깥 드롭다운과 같은 상자(.dropdownMenu)를 쓴다. */\n.dropdownGroup { position: relative; }\n.dropdownGroupArrow { margin-left: 12px; opacity: 0.7; flex-shrink: 0; }\n.dropdownGroupOpen { background-color: rgba(0, 123, 255, 0.12); }\n.dropdownMenu .dropdownFlyout {\n    top: -6px;                 /* 상자 안쪽 여백만큼 올려 첫 항목이 묶음과 같은 높이에 */\n    left: 100%;\n    margin-left: 1px;\n    animation: dropdown-flyout-fade 140ms ease-out;\n}\n.dropdownMenu .dropdownFlyoutFlip { left: auto; right: 100%; margin-left: 0; margin-right: 1px; }\n.dropdownItem:focus-visible { outline: 2px solid #007bff; outline-offset: -2px; }\n.dropdownItemDisabled { cursor: default; color: #9ca3af !important; font-style: italic; }\n.dropdownItemDisabled:hover { background-color: transparent !important; color: #9ca3af !important; }\n@keyframes dropdown-flyout-fade { from { opacity: 0; transform: translateX(-3px); } to { opacity: 1; transform: none; } }\n:global([data-theme=\"dark\"]) .dropdownGroupOpen { background: var(--color-hover) !important; }\n:global([data-theme=\"dark\"]) .dropdownItemDisabled { color: var(--color-text-muted) !important; }\n@media (prefers-reduced-motion: reduce) { .dropdownMenu .dropdownFlyout { animation: none; } }\n\n/* ── 머리줄 압축(Header.js fitHeader) — 넘칠 때만 단계적으로. 화면 확대를 올리면 같은 창에서도 넘친다 ── */\n.appHeader[data-compact=\"1\"],\n.appHeader[data-compact=\"2\"],\n.appHeader[data-compact=\"3\"] { padding: 0 10px; }\n.appHeader[data-compact=\"1\"] .headerLeft,\n.appHeader[data-compact=\"2\"] .headerLeft,\n.appHeader[data-compact=\"3\"] .headerLeft { gap: 10px; }\n.appHeader[data-compact=\"1\"] .menuBar,\n.appHeader[data-compact=\"2\"] .menuBar,\n.appHeader[data-compact=\"3\"] .menuBar { gap: 2px; }\n.appHeader[data-compact=\"1\"] .headerCenter,\n.appHeader[data-compact=\"2\"] .headerCenter,\n.appHeader[data-compact=\"3\"] .headerCenter { margin: 0 8px; }\n.appHeader[data-compact=\"1\"] .headerRight,\n.appHeader[data-compact=\"2\"] .headerRight,\n.appHeader[data-compact=\"3\"] .headerRight { gap: 8px; }\n.appHeader[data-compact=\"1\"] .connTypeName,\n.appHeader[data-compact=\"2\"] .connTypeName,\n.appHeader[data-compact=\"3\"] .connTypeName { display: none; }\n.appHeader[data-compact=\"1\"] .groupName,\n.appHeader[data-compact=\"2\"] .groupName { max-width: 90px; }\n.appHeader[data-compact=\"1\"] .userName,\n.appHeader[data-compact=\"2\"] .userName { display: inline-block; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle; }\n/* 2 — 메뉴는 아이콘만 */\n.appHeader[data-compact=\"2\"] .menuLabel,\n.appHeader[data-compact=\"3\"] .menuLabel { display: none; }\n.appHeader[data-compact=\"2\"] .menuItem,\n.appHeader[data-compact=\"3\"] .menuItem { padding: 6px 7px; }\n/* 3 — 이름 글자를 걷어 낸다(아이콘·툴팁은 남는다) */\n.appHeader[data-compact=\"3\"] .groupName,\n.appHeader[data-compact=\"3\"] .userName,\n.appHeader[data-compact=\"3\"] .connSession,\n.appHeader[data-compact=\"3\"] .connSessionNone,\n.appHeader[data-compact=\"3\"] .zoomResetButton { display: none; }\n\n/* 켜고 끄는 항목의 즐겨찾기 별(분석 모드·AI 에이전트, 2026-10-19) — ✓ 가 왼쪽 자리를 써서 오른쪽 끝에 둔다 */\n.menuItemPin {\n    margin-left: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n    border: none;\n    border-radius: 3px;\n    background: transparent;\n    color: #9ca3af;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: color 150ms ease, opacity 150ms ease;\n}\n.menuItemPin:hover { opacity: 1; }\n.menuItemPin.menuItemPinOn { color: #ca8a04; opacity: 1; }\n.menuItemPin.menuItemPinOn svg { fill: currentColor; }\n:global([data-theme=\"dark\"]) .menuItemPin.menuItemPinOn { color: #fbbf24; }\n@media (prefers-reduced-motion: reduce) {\n    .menuItemPin { transition: none; }\n}\n\n/* 확대 조절자의 −/+ 아이콘 — 숫자(100%)의 잉크가 줄 상자 가운데보다 약 1px 아래라 맞춘다(2026-11-05) */\n.zoomButton svg { transform: translateY(1px); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appHeader": `Header_appHeader__GDc7e`,
	"headerLeft": `Header_headerLeft__ttXYG`,
	"headerCenter": `Header_headerCenter__CiwCg`,
	"connectionInfo": `Header_connectionInfo__WOFDO`,
	"zoomControls": `Header_zoomControls__XmP9c`,
	"zoomButton": `Header_zoomButton__0zyX-`,
	"zoomDisplay": `Header_zoomDisplay__SOkzw`,
	"zoomResetButton": `Header_zoomResetButton__Mp2y9`,
	"darkModeToggle": `Header_darkModeToggle__CLYUY`,
	"languageSelect": `Header_languageSelect__4OSnM`,
	"headerRight": `Header_headerRight__VxUR3`,
	"appTitle": `Header_appTitle__BkgiM`,
	"appLogoTitle": `Header_appLogoTitle__KgbpW`,
	"appVersion": `Header_appVersion__xnFxV`,
	"menuBar": `Header_menuBar__ABX+P`,
	"menuItem": `Header_menuItem__T8vcp`,
	"userInfo": `Header_userInfo__lzJ+c`,
	"userButton": `Header_userButton__5Fpdq`,
	"userIcon": `Header_userIcon__ZboGH`,
	"userName": `Header_userName__Ge++-`,
	"dropdownArrow": `Header_dropdownArrow__721V4`,
	"userDropdown": `Header_userDropdown__4gsUM`,
	"userDropdownHeader": `Header_userDropdownHeader__mA3dY`,
	"userDropdownName": `Header_userDropdownName__EQqIS`,
	"userDropdownEmail": `Header_userDropdownEmail__MR73Y`,
	"userDropdownDivider": `Header_userDropdownDivider__sJ9NB`,
	"userDropdownItem": `Header_userDropdownItem__NmQT4`,
	"logoutIcon": `Header_logoutIcon__1vB+K`,
	"editIcon": `Header_editIcon__FJDUh`,
	"passwordIcon": `Header_passwordIcon__pRAzD`,
	"withdrawalIcon": `Header_withdrawalIcon__HerCs`,
	"menuContainer": `Header_menuContainer__ihXzU`,
	"dropdownMenu": `Header_dropdownMenu__2NtGH`,
	"dropdownItem": `Header_dropdownItem__1EgF+`,
	"menuItemShortcut": `Header_menuItemShortcut__lsYoX`,
	"participationGroupInfo": `Header_participationGroupInfo__O2brO`,
	"participationGroupButton": `Header_participationGroupButton__8D9iE`,
	"groupIcon": `Header_groupIcon__5KbHF`,
	"groupName": `Header_groupName__Unkes`,
	"participationGroupDropdown": `Header_participationGroupDropdown__+U56L`,
	"slideDown": `Header_slideDown__5z32N`,
	"participationGroupDropdownHeader": `Header_participationGroupDropdownHeader__PAKKK`,
	"participationGroupTitle": `Header_participationGroupTitle__1FEiP`,
	"currentGroupSection": `Header_currentGroupSection__yeYnq`,
	"currentGroupLabel": `Header_currentGroupLabel__ibbRO`,
	"currentGroupName": `Header_currentGroupName__GWk6g`,
	"participationGroupDropdownItem": `Header_participationGroupDropdownItem__mw0Xi`,
	"selectedGroup": `Header_selectedGroup__lBlBQ`,
	"availableGroupsLabel": `Header_availableGroupsLabel__xPyEb`,
	"participationGroupDivider": `Header_participationGroupDivider__OiTq2`,
	"joinIcon": `Header_joinIcon__vB7OB`,
	"leaveIcon": `Header_leaveIcon__mJxMt`,
	"groupSelectIcon": `Header_groupSelectIcon__KqxOu`,
	"modalOverlay": `Header_modalOverlay__76l12`,
	"aboutModal": `Header_aboutModal__fnS-C`,
	"aboutModalHeader": `Header_aboutModalHeader__lOnSf`,
	"closeButton": `Header_closeButton__vjHer`,
	"aboutModalContent": `Header_aboutModalContent__+f7Hw`,
	"aboutTagline": `Header_aboutTagline__8qerz`,
	"aboutBeta": `Header_aboutBeta__8ZcNl`,
	"aboutMeta": `Header_aboutMeta__zMb5F`,
	"aboutMetaRow": `Header_aboutMetaRow__F0Ep-`,
	"aboutMetaLabel": `Header_aboutMetaLabel__Oq9bj`,
	"aboutMetaValue": `Header_aboutMetaValue__8y5A-`,
	"aboutSection": `Header_aboutSection__rc3TU`,
	"aboutSectionTitle": `Header_aboutSectionTitle__FmciO`,
	"aboutList": `Header_aboutList__Kl1FN`,
	"aboutFooter": `Header_aboutFooter__Cartc`,
	"menuIcon": `Header_menuIcon__XGJoC`,
	"menuBadge": `Header_menuBadge__Gv9cW`,
	"menuBadgeAlert": `Header_menuBadgeAlert__R7laf`,
	"menuItemBadge": `Header_menuItemBadge__Mnlea`,
	"subMenuIcon": `Header_subMenuIcon__70AKK`,
	"menuItemContent": `Header_menuItemContent__HRhUR`,
	"menuSeparator": `Header_menuSeparator__ZdjkG`,
	"menuItemDisabled": `Header_menuItemDisabled__J-Mat`,
	"connTypeBadge": `Header_connTypeBadge__VglXT`,
	"connTypeDot": `Header_connTypeDot__fMzRF`,
	"connSession": `Header_connSession__imbML`,
	"connSessionNone": `Header_connSessionNone__0G+Xo`,
	"connElsewhere": `Header_connElsewhere__rmse+`,
	"connTypeName": `Header_connTypeName__rfts7`,
	"prodHeader": `Header_prodHeader__lHfSB`,
	"subMenuIconFav": `Header_subMenuIconFav__UFeKh`,
	"subMenuIconFavOn": `Header_subMenuIconFavOn__eCtUB`,
	"menuCheck": `Header_menuCheck__2CgOV`,
	"menuItemName": `Header_menuItemName__Mg2bQ`,
	"aboutUpdateRow": `Header_aboutUpdateRow__RPb0P`,
	"dropdownGroup": `Header_dropdownGroup__eSZBl`,
	"dropdownGroupArrow": `Header_dropdownGroupArrow__Bdyhq`,
	"dropdownGroupOpen": `Header_dropdownGroupOpen__-2hyf`,
	"dropdownFlyout": `Header_dropdownFlyout__v7wvf`,
	"dropdown-flyout-fade": `Header_dropdown-flyout-fade__Qqa2Z`,
	"dropdownFlyoutFlip": `Header_dropdownFlyoutFlip__aoAtR`,
	"dropdownItemDisabled": `Header_dropdownItemDisabled__DRZ7E`,
	"menuLabel": `Header_menuLabel__PTJd+`,
	"menuItemPin": `Header_menuItemPin__Si5bQ`,
	"menuItemPinOn": `Header_menuItemPinOn__NA60E`
};
export default ___CSS_LOADER_EXPORT___;
